var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('v-row',{staticStyle:{"display":"grid","padding-top":"100px"},attrs:{"id":"mainRow","justify":"center"}},[_c('swap-card')],1),_c('v-row',{staticClass:"pt-10",attrs:{"justify":"center"}},[_c('nfts-pool-list')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }